import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-securities-trading-form',
    templateUrl: './securities-trading-form.component.html',
})
export class SecuritiesTradingFormComponent {
    @Input({ required: true }) form!: FormGroup;
}
